import type { CreateMcpConnectorInput } from '../types';

export interface Step3ReviewProps {
  value: CreateMcpConnectorInput;
  onBack: () => void;
  onSubmit: () => void;
  isSubmitting?: boolean;
}

/**
 * Sprint A4 S1 PR 3 — Task 8. Step 3 do wizard: revisão + submit.
 *
 * Mostra resumo dos campos do form + fingerprint da apiKey (••••••••XYZ —
 * só os 3 últimos chars). Banner explica que handshake roda em background
 * após salvar (~5s típico).
 */
export function McpConnectorStep3Review({
  value,
  onBack,
  onSubmit,
  isSubmitting = false,
}: Step3ReviewProps): JSX.Element {
  const fingerprint = `••••••••${value.apiKey.slice(-3)}`;

  return (
    <div className="flex flex-col gap-4">
      <div className="rounded-lg border border-border-subtle bg-surface p-4">
        <h3 className="mb-3 text-sm font-semibold text-text-primary">Resumo do cadastro</h3>
        <dl className="space-y-2 text-sm">
          <Row label="Nome visível" value={value.displayName} />
          <Row label="Slug" value={value.slug} mono />
          <Row label="Namespace" value={value.namespace} mono />
          <Row label="URL do servidor" value={value.serverUrl} mono />
          <Row label="Autenticação" value="API Key" />
          <Row label="Chave (fingerprint)" value={fingerprint} mono />
        </dl>
      </div>

      <div className="rounded bg-blue-50 p-3 text-xs text-blue-900">
        Ao salvar, testaremos a conexão automaticamente em segundo plano. Você verá o resultado no
        card do conector (~5s).
      </div>

      <div className="mt-4 flex justify-between">
        <button
          type="button"
          onClick={onBack}
          disabled={isSubmitting}
          className="rounded border border-border-subtle px-4 py-2 text-sm hover:bg-bg-muted disabled:opacity-50"
        >
          ← Voltar
        </button>
        <button
          type="button"
          onClick={onSubmit}
          disabled={isSubmitting}
          className="rounded bg-accent px-4 py-2 text-sm text-white hover:bg-accent-hover disabled:opacity-50"
        >
          {isSubmitting ? 'Salvando...' : 'Salvar e testar'}
        </button>
      </div>
    </div>
  );
}

function Row({
  label,
  value,
  mono = false,
}: {
  label: string;
  value: string;
  mono?: boolean;
}): JSX.Element {
  return (
    <div className="flex justify-between gap-4">
      <dt className="text-text-secondary">{label}</dt>
      <dd className={mono ? 'font-mono text-text-primary' : 'text-text-primary'}>{value}</dd>
    </div>
  );
}
